export default __webpack_public_path__ + "static/media/kidcoBeer.2e28f3bc.jpg";